import { IAppState } from '../../../redux';
import { selectAddressEditingRestrictionData } from './selectAddressEditingRestrictionData';

export const selectIsAddressEditingExpired = (state: IAppState): boolean => {
  const editingRestrictionData = selectAddressEditingRestrictionData(state);

  return !!editingRestrictionData?.isRestricted;
};
